import { gql } from '@apollo/client'

import { BRAND_DETAILS_FRAGMENT } from '../../../brand-curation-tasks/graphql/fragments'

import MENU_DATA_CONTEXT_FRAGMENT from './menu-data-context-fragment'
import MENU_DATA_DISH_FRAGMENT from './menu-data-dish-fragment'

const MENU_DATA_FRAGMENT = gql`
  fragment MenuDataFragment on MenuData {
    menuCurationTaskId
    menuId
    menuCurationTaskUrl
    brand {
      ...BrandDetailsFragment
    }
    dishes {
      ...MenuDataDishFragment
    }
    menuContext {
      ...MenuDataContextFragment
    }
  }
  ${BRAND_DETAILS_FRAGMENT}
  ${MENU_DATA_DISH_FRAGMENT}
  ${MENU_DATA_CONTEXT_FRAGMENT}
`

export default MENU_DATA_FRAGMENT
